import { escapeHtml } from '../core/html.js?v=6.87.12';

const SEA_STATUS_VALUES = new Set([
  'в море', 'в пути', 'на переходе', 'в рейсе', 'идет', 'идёт',
  'at sea', 'at_sea', 'in sea', 'in_sea', 'sea',
  'underway', 'sailing', 'on passage', 'on_passage',
  'in transit', 'in_transit', 'transit', 'en route', 'en_route',
]);
const NOT_SEA_PHASES = new Set(['in_port', 'port', 'berthed', 'moored', 'planned', 'completed', 'cancelled', 'archived']);

export const VESSEL_TYPE_ANIMATION_PROFILES = Object.freeze({
  'балкер': { model: 'bulkCarrier', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'bulk carrier': { model: 'bulkCarrier', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'bulk_carrier': { model: 'bulkCarrier', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'bulker': { model: 'bulkCarrier', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'контейнеровоз': { model: 'containerShip', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'container ship': { model: 'containerShip', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'container_ship': { model: 'containerShip', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'container': { model: 'containerShip', fallbackLoaM: 180, lightsProfile: 'powerDriven50Plus' },
  'ro-ro': { model: 'roRo', fallbackLoaM: 190, lightsProfile: 'powerDriven50Plus' },
  'roro': { model: 'roRo', fallbackLoaM: 190, lightsProfile: 'powerDriven50Plus' },
  'ро-ро': { model: 'roRo', fallbackLoaM: 190, lightsProfile: 'powerDriven50Plus' },
  'танкер': { model: 'tanker', fallbackLoaM: 185, lightsProfile: 'powerDriven50Plus' },
  'tanker': { model: 'tanker', fallbackLoaM: 185, lightsProfile: 'powerDriven50Plus' },
  'сухогруз': { model: 'generalCargo', fallbackLoaM: 120, lightsProfile: 'powerDriven50Plus' },
  'general cargo': { model: 'generalCargo', fallbackLoaM: 120, lightsProfile: 'powerDriven50Plus' },
  'general_cargo': { model: 'generalCargo', fallbackLoaM: 120, lightsProfile: 'powerDriven50Plus' },
  'multipurpose': { model: 'generalCargo', fallbackLoaM: 120, lightsProfile: 'powerDriven50Plus' },
  'multi-purpose': { model: 'generalCargo', fallbackLoaM: 120, lightsProfile: 'powerDriven50Plus' },
  'парусник': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'парусное': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'парусное судно': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'sailing': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'sailing vessel': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'sailing_vessel': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'sailboat': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'yacht': { model: 'sailingVessel', fallbackLoaM: 18, lightsProfile: 'sailingRule25' },
  'рыбопромысловое': { model: 'fishingVessel', fallbackLoaM: 35, lightsProfile: 'powerDrivenUnder50' },
  'рыболовное': { model: 'fishingVessel', fallbackLoaM: 35, lightsProfile: 'powerDrivenUnder50' },
  'fishing': { model: 'fishingVessel', fallbackLoaM: 35, lightsProfile: 'powerDrivenUnder50' },
  'fishing vessel': { model: 'fishingVessel', fallbackLoaM: 35, lightsProfile: 'powerDrivenUnder50' },
  'fishing_vessel': { model: 'fishingVessel', fallbackLoaM: 35, lightsProfile: 'powerDrivenUnder50' },
});

export const DEFAULT_VESSEL_ANIMATION_PROFILE = Object.freeze({
  model: 'generalCargo', fallbackLoaM: 120, lightsProfile: 'powerDriven50Plus',
});

export const SEA_PLANES = Object.freeze({
  far: { key: 'far', scale: 0.50, bottom: 136, zIndex: 10, durationS: 132, opacity: 0.70, bob: 0.30, direction: 'eastbound' },
  mid: { key: 'mid', scale: 0.78, bottom: 74, zIndex: 20, durationS: 108, opacity: 0.91, bob: 0.52, direction: 'westbound' },
  front: { key: 'front', scale: 1.06, bottom: 4, zIndex: 30, durationS: 92, opacity: 1, bob: 0.72, direction: 'eastbound' },
});

const SEA_PLANE_ORDER = Object.freeze(['far', 'mid', 'front']);
const SEA_PLANE_DIRECTIONS = Object.freeze({ far: 'eastbound', mid: 'westbound', front: 'eastbound' });
const COLREG_LIGHT_ROLES = Object.freeze(['masthead-forward', 'masthead-aft', 'port-sidelight', 'starboard-sidelight', 'sternlight']);
// Contract literals for regression checks: data-colregs-rule="23" data-colregs-rule="25" data-colregs-config="A" data-colregs-config="B" data-colregs-config="S" data-colregs-light="masthead-forward" data-colregs-light="masthead-aft" data-colregs-light="port-sidelight" data-colregs-light="starboard-sidelight" data-colregs-light="sternlight" data-colregs-sector-deg="225" data-colregs-sector-deg="112.5" data-colregs-sector-deg="135" data-colregs-position="centerline-forward" data-colregs-position="centerline-aft-higher" data-colregs-position="port-side" data-colregs-position="starboard-side" data-colregs-position="centerline-stern" data-colregs-observer-aspect="starboard-beam" data-colregs-observer-aspect="port-beam" data-colregs-observer-aspect="ahead" data-colregs-observer-aspect="astern"

function normalizeText(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ');
}

function numberOrNull(value) {
  if (value === null || value === undefined || value === '') return null;
  const normalized = String(value).replace(',', '.').replace(/[^0-9.\-]/g, '');
  const number = Number(normalized);
  return Number.isFinite(number) && number > 0 ? number : null;
}

function firstText(...values) {
  for (const value of values) {
    const text = String(value ?? '').trim();
    if (text !== '') return text;
  }
  return '';
}

function vesselIdentityKey(item = {}) {
  const rawId = firstText(item.vessel_id, item.vesselId, item.id);
  if (rawId) return `id:${normalizeText(rawId)}`;
  const rawName = firstText(item.vessel_name, item.name);
  if (rawName) return `name:${normalizeText(rawName)}`;
  return '';
}

function dedupeVesselsByIdentity(vessels = []) {
  const seen = new Set();
  return vessels.filter((vessel, index) => {
    const key = vesselIdentityKey(vessel) || `row:${index}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function oceanVesselRenderKey(vessel = {}) {
  return [
    vesselIdentityKey(vessel),
    normalizeText(vessel.name),
    normalizeText(vessel.model),
    normalizeText(vessel.lightsProfile),
    String(Math.round(Number(vessel.loaM || 0) * 10) / 10),
  ].join('|');
}

function oceanRenderSignature(visible = []) {
  if (!visible.length) return 'fallback:sailing-vessel-underway-rule-25';
  return `live:${visible.map(oceanVesselRenderKey).sort().join('||')}`;
}

function markOceanRendered(ocean, signature) {
  if (!ocean || !signature) return;
  ocean.setAttribute('data-ocean-render-signature', signature);
}

function clearOceanRendered(ocean) {
  if (!ocean) return;
  ocean.removeAttribute('data-ocean-render-signature');
}

function hasSameOceanRender(ocean, signature) {
  return Boolean(ocean && signature && ocean.getAttribute('data-ocean-render-signature') === signature && ocean.innerHTML);
}

function hashText(value) {
  const text = String(value ?? '');
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function resolveVesselAnimationProfile(vessel = {}, instruction = {}) {
  const rawType = firstText(
    vessel.type,
    vessel.vessel_type,
    vessel.vessel_type_label,
    vessel.vessel_type_value,
    instruction.vessel_type,
    instruction.type,
  );
  const key = normalizeText(rawType);
  const profile = VESSEL_TYPE_ANIMATION_PROFILES[key] || DEFAULT_VESSEL_ANIMATION_PROFILE;
  const loaM = resolveLoa(vessel, instruction, profile);
  const lightsProfile = profile.model === 'sailingVessel'
    ? 'sailingRule25'
    : (loaM >= 50 ? 'powerDriven50Plus' : 'powerDrivenUnder50');

  return { ...profile, lightsProfile, loaM };
}

export function resolveLoa(vessel = {}, instruction = {}, profile = DEFAULT_VESSEL_ANIMATION_PROFILE) {
  return numberOrNull(vessel.loa)
    ?? numberOrNull(vessel.loa_m)
    ?? numberOrNull(vessel.length)
    ?? numberOrNull(vessel.vessel_loa)
    ?? numberOrNull(instruction.vessel_loa)
    ?? numberOrNull(instruction.loa)
    ?? profile.fallbackLoaM;
}

// Only two dispatcher-stated states are a position; any other manual label (waiting, emergency, ...)
// is not, and leaves the decision to the schedule. Mirrors backend VesselStateResolver::normalizeState.
export function explicitSeaState(manualStatus) {
  const key = normalizeText(manualStatus);
  if (['in_port', 'in port', 'port', 'в порту'].includes(key)) return 'in_port';
  if (['underway', 'at_sea', 'at sea', 'sea', 'en_route', 'en route', 'в море', 'в пути'].includes(key)) return 'at_sea';
  return null;
}

export function isInstructionAtSea(item = {}) {
  // A stated fact beats the schedule-derived phase.
  // A manual state counts only while it has not expired (the server already masks expired ones; the
  // check here covers the gap until the next refresh). Instants carry an explicit offset - no device zone.
  const expiresMs = Date.parse(String(item.manual_status_expires_at || ''));
  const explicit = item.manual_status_expires_at !== undefined && !(expiresMs > Date.now()) ? null : explicitSeaState(item.manual_status);
  if (explicit !== null) return explicit === 'at_sea';
  const phase = normalizeText(item.operational_phase || item.phase || item.voyage_phase || item.position_status);
  if (NOT_SEA_PHASES.has(phase)) return false;
  if ([
    'underway', 'at_sea', 'in_sea', 'sea', 'on passage', 'on_passage',
    'в море', 'в пути', 'на переходе', 'в рейсе', 'in transit', 'in_transit', 'en route', 'en_route',
  ].includes(phase)) return true;

  const statuses = [
    item.status,
    item.instruction_status,
    item.voyage_status,
    item.operational_status,
    item.sea_status,
  ].map(normalizeText).filter(Boolean);
  if (statuses.some(status => SEA_STATUS_VALUES.has(status))) return true;
  return false;
}

export function buildDashboardSeaVessels(dashboardData = {}) {
  const source = Array.isArray(dashboardData.sea_vessels)
    ? dashboardData.sea_vessels
    : (Array.isArray(dashboardData.instructions)
      ? dashboardData.instructions
      : (Array.isArray(dashboardData.fleet_rows) ? dashboardData.fleet_rows : []));

  return dedupeVesselsByIdentity(source.filter(isInstructionAtSea))
    .map((instruction, index) => {
      const vessel = instruction.vessel && typeof instruction.vessel === 'object'
        ? instruction.vessel
        : {
          id: instruction.vessel_id,
          name: instruction.vessel_name,
          type: instruction.vessel_type || instruction.vessel_type_label || instruction.vessel_type_value || instruction.type,
          loa: instruction.vessel_loa || instruction.loa,
          navigation_status: instruction.navigation_status,
          activity_status: instruction.activity_status,
          operation_mode: instruction.operation_mode,
          fishing_mode: instruction.fishing_mode,
        };
      const profile = resolveVesselAnimationProfile(vessel, instruction);
      const id = firstText(vessel.id, instruction.vessel_id, instruction.instruction_id, instruction.id, `vessel-${index}`);
      const name = firstText(vessel.name, instruction.vessel_name, instruction.name, 'VESSEL').toUpperCase();
      return {
        id,
        name,
        type: firstText(vessel.type, instruction.vessel_type, instruction.vessel_type_label, instruction.type),
        status: firstText(instruction.status, instruction.voyage_status, instruction.operational_phase),
        model: profile.model,
        lightsProfile: profile.lightsProfile,
        loaM: profile.loaM,
      };
    })
    .filter(Boolean);
}

const COLREG_LIGHT_SPECS = Object.freeze({
  'masthead-forward': { color: 'white', sectorDeg: 225, direction: 'ahead-112.5-each-side', visibleAspects: ['ahead', 'port-beam', 'starboard-beam'] },
  'masthead-aft': { color: 'white', sectorDeg: 225, direction: 'ahead-112.5-each-side', visibleAspects: ['ahead', 'port-beam', 'starboard-beam'] },
  'port-sidelight': { color: 'red', sectorDeg: 112.5, direction: 'ahead-to-port', visibleAspects: ['ahead', 'port-beam'] },
  'starboard-sidelight': { color: 'green', sectorDeg: 112.5, direction: 'ahead-to-starboard', visibleAspects: ['ahead', 'starboard-beam'] },
  sternlight: { color: 'white', sectorDeg: 135, direction: 'astern-67.5-each-side', visibleAspects: ['astern'] },
});

const COLREG_LIGHT_POSITIONS = Object.freeze({
  'masthead-forward': 'centerline-forward',
  'masthead-aft': 'centerline-aft-higher',
  'port-sidelight': 'port-side-forward',
  'starboard-sidelight': 'starboard-side-forward',
  sternlight: 'centerline-stern',
});

function colregAspectForDirection(direction) {
  if (direction === 'westbound') return 'port-beam';
  if (direction === 'astern') return 'astern';
  if (direction === 'ahead') return 'ahead';
  return 'starboard-beam';
}

function isLightVisibleForAspect(role, aspect) {
  const visibleAspects = COLREG_LIGHT_SPECS[role]?.visibleAspects || [];
  return visibleAspects.includes(aspect);
}

function lightCircle(role, className, x, y, r = 3.0, rule = '23', aspect = 'starboard-beam') {
  if (!isLightVisibleForAspect(role, aspect)) return '';
  const spec = COLREG_LIGHT_SPECS[role] || { color: '', sectorDeg: '', direction: '', visibleAspects: [] };
  const position = COLREG_LIGHT_POSITIONS[role] || '';
  // Lamp = small housing (non-contract decoration) + the contract-bearing light core, same anchor point.
  const housingR = Math.round((r + 1.3) * 100) / 100;
  return `<circle class="rc5-vessel-lamp-housing" cx="${x}" cy="${y}" r="${housingR}"/><circle data-colregs-rule="${rule}" data-colregs-light="${role}" data-colregs-color="${spec.color}" data-colregs-sector-deg="${spec.sectorDeg}" data-colregs-direction="${spec.direction}" data-colregs-position="${position}" data-colregs-observer-aspect="${aspect}" data-colregs-visible-aspects="${spec.visibleAspects.join(' ')}" class="rc5-vessel-light ${className}" cx="${x}" cy="${y}" r="${r}"/>`;
}

function sideLightCircles(points, radius = 2.6, rule = '23', aspect = 'starboard-beam') {
  const side = points.side || { x: 224, y: 76 };
  return `${lightCircle('port-sidelight', 'rc5-vessel-light--side-port', side.x, side.y, radius, rule, aspect)}${lightCircle('starboard-sidelight', 'rc5-vessel-light--side-starboard', side.x, side.y, radius, rule, aspect)}`;
}

function powerDriven50PlusLights(points, aspect = 'starboard-beam') {
  return `<g class="rc5-vessel-navigation-lights" data-colregs-rule="23" data-colregs-config="A" data-colregs-profile="power-driven-vessel-50m-plus-underway" data-colregs-observer-aspect="${aspect}" data-colregs-lights-count="5" data-colregs-installed-lights-count="5" data-colregs-visible-lights-model="aspect-filtered">
    <path class="rc5-vessel-mast" d="M${points.aft.x} ${points.aft.footY}V${points.aft.y}M${points.forward.x} ${points.forward.footY}V${points.forward.y}"/>
    ${lightCircle('masthead-aft', 'rc5-vessel-light--mast', points.aft.x, points.aft.y, 3.0, '23', aspect)}
    ${lightCircle('masthead-forward', 'rc5-vessel-light--mast', points.forward.x, points.forward.y, 2.9, '23', aspect)}
    ${sideLightCircles(points, 2.6, '23', aspect)}
    ${lightCircle('sternlight', 'rc5-vessel-light--stern', points.stern.x, points.stern.y, 2.7, '23', aspect)}
  </g>`;
}

function powerDrivenUnder50Lights(points, aspect = 'starboard-beam') {
  return `<g class="rc5-vessel-navigation-lights" data-colregs-rule="23" data-colregs-config="B" data-colregs-profile="power-driven-vessel-12-50m-underway" data-colregs-observer-aspect="${aspect}" data-colregs-lights-count="4" data-colregs-installed-lights-count="4" data-colregs-visible-lights-model="aspect-filtered">
    <path class="rc5-vessel-mast" d="M${points.forward.x} ${points.forward.footY}V${points.forward.y}"/>
    ${lightCircle('masthead-forward', 'rc5-vessel-light--mast', points.forward.x, points.forward.y, 2.9, '23', aspect)}
    ${sideLightCircles(points, 2.5, '23', aspect)}
    ${lightCircle('sternlight', 'rc5-vessel-light--stern', points.stern.x, points.stern.y, 2.6, '23', aspect)}
  </g>`;
}

function sailingVesselRule25Lights(points, aspect = 'starboard-beam') {
  return `<g class="rc5-vessel-navigation-lights rc5-vessel-navigation-lights--sailing" data-colregs-rule="25" data-colregs-config="S" data-colregs-profile="sailing-vessel-underway" data-colregs-observer-aspect="${aspect}" data-colregs-lights-count="3" data-colregs-installed-lights-count="3" data-colregs-visible-lights-model="aspect-filtered" data-colregs-optional-all-round="not-rendered">
    ${sideLightCircles(points, 2.4, '25', aspect)}
    ${lightCircle('sternlight', 'rc5-vessel-light--stern', points.stern.x, points.stern.y, 2.5, '25', aspect)}
  </g>`;
}

function navigationLights(profile, points, aspect = 'starboard-beam') {
  if (profile === 'sailingRule25') return sailingVesselRule25Lights(points, aspect);
  return profile === 'powerDriven50Plus' ? powerDriven50PlusLights(points, aspect) : powerDrivenUnder50Lights(points, aspect);
}

// Every hull-side "card" (bulk/container/ro-ro/tanker/general cargo) shares one nameplate
// zone: it sits on the hull plating between the sheerline and the waterline, clear of the
// superstructure, the cargo detail, and both masts.
const STANDARD_NAME_PLATE = Object.freeze({ eastX: 94, westX: 166, y: 92, width: 88, maxFont: 7.8 });
const MODEL_NAME_PLATES = Object.freeze({
  bulkCarrier: STANDARD_NAME_PLATE,
  containerShip: STANDARD_NAME_PLATE,
  roRo: STANDARD_NAME_PLATE,
  tanker: STANDARD_NAME_PLATE,
  generalCargo: STANDARD_NAME_PLATE,
  fishingVessel: { eastX: 74, westX: 186, y: 89, width: 54, maxFont: 6.6 },
  sailingVessel: { eastX: 78, westX: 182, y: 94, width: 50, maxFont: 6.2 },
});

function namePlateForModel(model) {
  return MODEL_NAME_PLATES[model] || MODEL_NAME_PLATES.generalCargo;
}

function truncateVesselName(name, maxChars = 18) {
  const text = String(name || '').trim().toUpperCase();
  if (text.length <= maxChars) return text;
  return `${text.slice(0, Math.max(1, maxChars - 1))}…`;
}

function vesselNamePlate(vessel, direction) {
  const plate = namePlateForModel(vessel.model);
  const anchor = direction === 'westbound' ? 'end' : 'start';
  const x = direction === 'westbound' ? plate.westX : plate.eastX;
  const maxChars = Math.max(9, Math.min(22, Math.floor(plate.width / Math.max(3.0, plate.maxFont * 0.58))));
  const name = truncateVesselName(firstText(vessel.name, 'VESSEL'), maxChars);
  const fontSize = Math.max(5.2, Math.min(plate.maxFont, plate.width / Math.max(name.length * 0.64, 1)));

  return `<svg class="rc5-ocean-vessel__name-svg" viewBox="0 0 260 120" aria-hidden="true" focusable="false">
    <text class="rc5-ocean-vessel__name-text" x="${x}" y="${plate.y}" text-anchor="${anchor}" font-size="${fontSize.toFixed(2)}">${escapeHtml(name)}</text>
  </svg>`;
}

// Base SVG orientation: strict starboard-side profile, bow to the right (hull tip ≈ x246),
// stern to the left (hull heel ≈ x14). One anchor point = one mast + one light: every mast
// path and the lamp sitting on it are always built from the same {x, y, footY}, so they can
// never drift apart. `side` is the single rail point shared by the port/starboard sidelight —
// only one of the pair is ever visible for a given observer aspect.
const STANDARD_LIGHT_POINTS = Object.freeze({
  aft: { x: 53, y: 13, footY: 24 },
  forward: { x: 210, y: 32, footY: 76 },
  side: { x: 76, y: 76 },
  stern: { x: 20, y: 82 },
});

const LIGHT_POINTS = Object.freeze({
  bulkCarrier: STANDARD_LIGHT_POINTS,
  containerShip: STANDARD_LIGHT_POINTS,
  // Ro-Ro's foremast stands on the box roof (y50), not on an open foredeck.
  roRo: Object.freeze({ ...STANDARD_LIGHT_POINTS, forward: { x: 195, y: 30, footY: 50 } }),
  tanker: STANDARD_LIGHT_POINTS,
  generalCargo: STANDARD_LIGHT_POINTS,
  // Annex I §3: a single masthead light must stand forward of amidships (hull runs x26-232,
  // amidships ≈ x129) — independent of where the wheelhouse itself sits, since Rule 23's
  // reference deck plan puts this wheelhouse amidships/aft. Own forward pole, not roof-mounted.
  fishingVessel: Object.freeze({
    forward: { x: 204, y: 27, footY: 80 },
    side: { x: 112, y: 80 },
    stern: { x: 34, y: 84 },
  }),
  sailingVessel: Object.freeze({
    side: { x: 176, y: 88 },
    stern: { x: 66, y: 92 },
  }),
});

function lightsForModel(model, profile, aspect = 'starboard-beam') {
  return navigationLights(profile, LIGHT_POINTS[model] || LIGHT_POINTS.generalCargo, aspect);
}

// Shared hull template for the five "big ship" cards (bulk / container / ro-ro / tanker /
// general cargo): identical sheerline, waterline, and aft-superstructure stack, so the deck
// detail is the only thing that changes between them and nothing can drift out of place.
const STANDARD_HULL_D = 'M14 76H224L246 90L232 104H54C30 104 16 94 14 76Z';
const STANDARD_WATERLINE_D = 'M40 99H222';
const STANDARD_SUPERSTRUCTURE = `<path class="rc5-vessel-superstructure" d="M32 44h38v32H32zM42 31h18v13H42zM49 24h8v7h-8z"/>
      <g class="rc5-vessel-window-detail"><rect x="39" y="52" width="6" height="4" rx=".7"/><rect x="48" y="52" width="6" height="4" rx=".7"/><rect x="57" y="52" width="6" height="4" rx=".7"/><rect x="44" y="35" width="5" height="4" rx=".6"/><rect x="53" y="35" width="5" height="4" rx=".6"/></g>`;

const MODEL_RENDERERS = Object.freeze({
  bulkCarrier(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--bulk" d="${STANDARD_HULL_D}"/>
      <path class="rc5-vessel-bootline" d="${STANDARD_WATERLINE_D}"/>
      ${STANDARD_SUPERSTRUCTURE}
      <g class="rc5-vessel-hatch-detail rc5-vessel-hatch-detail--bulk">
        <rect x="84" y="60" width="26" height="16" rx="1.2"/><rect x="112" y="60" width="26" height="16" rx="1.2"/><rect x="140" y="60" width="26" height="16" rx="1.2"/><rect x="168" y="60" width="26" height="16" rx="1.2"/>
      </g>
      ${lightsForModel('bulkCarrier', profile, aspect)}
    </svg>`;
  },
  containerShip(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--container" d="${STANDARD_HULL_D}"/>
      <path class="rc5-vessel-bootline" d="${STANDARD_WATERLINE_D}"/>
      ${STANDARD_SUPERSTRUCTURE}
      <g class="rc5-vessel-container-stack">
        <rect class="rc5-vessel-container--blue" x="84" y="50" width="22" height="13"/><rect class="rc5-vessel-container--red" x="106" y="50" width="22" height="13"/><rect class="rc5-vessel-container--slate" x="128" y="50" width="22" height="13"/><rect class="rc5-vessel-container--sand" x="150" y="50" width="22" height="13"/><rect class="rc5-vessel-container--blue" x="172" y="50" width="22" height="13"/>
        <rect class="rc5-vessel-container--sand" x="84" y="63" width="22" height="13"/><rect class="rc5-vessel-container--blue" x="106" y="63" width="22" height="13"/><rect class="rc5-vessel-container--red" x="128" y="63" width="22" height="13"/><rect class="rc5-vessel-container--slate" x="150" y="63" width="22" height="13"/><rect class="rc5-vessel-container--sand" x="172" y="63" width="22" height="13"/>
        <path class="rc5-vessel-container-line" d="M84 63H194M106 50V76M128 50V76M150 50V76M172 50V76"/>
      </g>
      ${lightsForModel('containerShip', profile, aspect)}
    </svg>`;
  },
  roRo(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--roro" d="${STANDARD_HULL_D}"/>
      <path class="rc5-vessel-bootline" d="${STANDARD_WATERLINE_D}"/>
      <path class="rc5-vessel-roro-box" d="M70 50h152v26H70z"/>
      <path class="rc5-vessel-superstructure" d="M42 32h28v18H42zM49 24h8v8h-8z"/>
      <g class="rc5-vessel-window-detail rc5-vessel-window-detail--roro">
        <rect x="80" y="57" width="6" height="5" rx=".6"/><rect x="94" y="57" width="6" height="5" rx=".6"/><rect x="108" y="57" width="6" height="5" rx=".6"/><rect x="122" y="57" width="6" height="5" rx=".6"/><rect x="136" y="57" width="6" height="5" rx=".6"/><rect x="150" y="57" width="6" height="5" rx=".6"/><rect x="164" y="57" width="6" height="5" rx=".6"/><rect x="178" y="57" width="6" height="5" rx=".6"/><rect x="192" y="57" width="6" height="5" rx=".6"/>
      </g>
      ${lightsForModel('roRo', profile, aspect)}
    </svg>`;
  },
  tanker(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--tanker" d="${STANDARD_HULL_D}"/>
      <path class="rc5-vessel-bootline" d="${STANDARD_WATERLINE_D}"/>
      ${STANDARD_SUPERSTRUCTURE}
      <g class="rc5-vessel-pipe-detail">
        <path d="M84 64H196M84 70H196M100 64c4-8 12-8 16 0M164 64c4-8 12-8 16 0M188 64V52H196"/>
        <circle cx="130" cy="58" r="4"/><circle cx="108" cy="70" r="2"/><circle cx="172" cy="70" r="2"/>
      </g>
      ${lightsForModel('tanker', profile, aspect)}
    </svg>`;
  },
  generalCargo(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--cargo" d="${STANDARD_HULL_D}"/>
      <path class="rc5-vessel-bootline" d="${STANDARD_WATERLINE_D}"/>
      ${STANDARD_SUPERSTRUCTURE}
      <g class="rc5-vessel-cargo-detail">
        <rect class="rc5-vessel-cargo--hold" x="88" y="64" width="32" height="12" rx="1.3"/><rect class="rc5-vessel-cargo--hold" x="160" y="64" width="32" height="12" rx="1.3"/>
        <rect class="rc5-vessel-container--sand" x="126" y="66" width="12" height="10"/><rect class="rc5-vessel-container--blue" x="139" y="66" width="12" height="10"/>
      </g>
      <g class="rc5-vessel-crane-detail">
        <path d="M100 76V48L124 60"/><path d="M172 76V48L148 60"/>
      </g>
      ${lightsForModel('generalCargo', profile, aspect)}
    </svg>`;
  },
  fishingVessel(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--fishing" d="M26 80H198L232 92 214 100H62C40 100 28 92 26 80Z"/>
      <path class="rc5-vessel-bootline" d="M46 96h150"/>
      <path class="rc5-vessel-superstructure" d="M132 46h34v34h-34zM142 36h14v10h-14z"/>
      <g class="rc5-vessel-window-detail"><rect x="138" y="53" width="6" height="4" rx=".6"/><rect x="148" y="53" width="6" height="4" rx=".6"/><rect x="158" y="53" width="6" height="4" rx=".6"/></g>
      <g class="rc5-vessel-fishing-gear">
        <path d="M52 80 70 50 88 80"/>
      </g>
      ${lightsForModel('fishingVessel', profile, aspect)}
    </svg>`;
  },
  sailingVessel(profile, aspect = 'starboard-beam') {
    return `<svg class="rc5-ocean-vessel__svg rc5-ocean-vessel__svg--sailing" viewBox="0 0 260 120" role="img" aria-hidden="true">
      <path class="rc5-vessel-hull rc5-vessel-hull--sailing" d="M56 86H176L214 96 200 102H80C64 102 58 96 56 86Z"/>
      <path class="rc5-vessel-bootline" d="M72 98h116"/>
      <rect class="rc5-vessel-superstructure rc5-vessel-superstructure--sailing" x="136" y="78" width="30" height="8" rx="1.5"/>
      <path class="rc5-vessel-sail rc5-vessel-sail--main" d="M150 20C126 38 108 58 100 80H150Z"/>
      <path class="rc5-vessel-sail rc5-vessel-sail--jib" d="M150 34 206 84H150Z"/>
      <path class="rc5-vessel-sail-mast" d="M150 86V18"/>
      ${lightsForModel('sailingVessel', 'sailingRule25', aspect)}
    </svg>`;
  },
});
function vesselBaseWidthPx(vessel) {
  const loa = Math.max(25, Math.min(240, Number(vessel.loaM || 120)));
  if (vessel.model === 'sailingVessel') return Math.round(Math.max(116, Math.min(150, loa * 0.95 + 64)));
  if (vessel.model === 'fishingVessel') return Math.round(Math.max(104, Math.min(138, loa * 0.9 + 64)));
  if (vessel.model === 'generalCargo') return Math.round(Math.max(158, Math.min(220, loa * 0.74 + 74)));
  return Math.round(Math.max(168, Math.min(242, loa * 0.74 + 82)));
}

export function assignSeaPlane(vessel = {}, index = 0) {
  const seed = hashText(`${vessel.id || ''}|${vessel.name || ''}|${vessel.model || ''}`);
  return SEA_PLANE_ORDER[(seed + index) % SEA_PLANE_ORDER.length];
}

function vesselMarkup(vessel, index, planeSlot = {}) {
  const seed = hashText(`${vessel.id || ''}|${vessel.name || ''}|${index}`);
  const planeKey = planeSlot.planeKey || assignSeaPlane(vessel, index);
  const plane = SEA_PLANES[planeKey] || SEA_PLANES.mid;
  const direction = SEA_PLANE_DIRECTIONS[planeKey] || plane.direction || 'eastbound';
  const colregAspect = colregAspectForDirection(direction);
  const renderer = MODEL_RENDERERS[vessel.model] || MODEL_RENDERERS.generalCargo;
  const width = vesselBaseWidthPx(vessel);
  const jitter = planeKey === 'front' ? ((seed >>> 5) % 3) - 1 : ((seed >>> 5) % 5) - 2;
  const bottom = Math.max(2, plane.bottom + jitter);
  const duration = plane.durationS || 96;
  const planeCount = Math.max(1, Number(planeSlot.planeCount || 1));
  const planeIndex = Math.max(0, Number(planeSlot.planeIndex || 0));
  const globalIndex = Math.max(0, Number(planeSlot.globalIndex || 0));
  const globalCount = Math.max(1, Number(planeSlot.globalCount || planeCount));
  const spacingRatio = Number.isFinite(Number(planeSlot.phase))
    ? Number(planeSlot.phase)
    : (planeIndex + 0.5) / planeCount;
  const fallbackRole = firstText(planeSlot.fallback);
  const delay = 0;
  const staticLeft = direction === 'westbound' ? '100%' : '0%';
  const namePlate = vesselNamePlate(vessel, direction);
  const safePlaneKey = escapeHtml(planeKey);
  const classes = [
    'rc5-ocean-vessel',
    `rc5-ocean-vessel--${direction}`,
    `rc5-ocean-vessel--${escapeHtml(vessel.model)}`,
    `rc5-ocean-vessel--plane-${safePlaneKey}`,
  ].join(' ');

  return `<div class="${classes}" data-sea-plane="${safePlaneKey}" data-plane-direction="${direction}" data-plane-slot="${planeIndex + 1}/${planeCount}" data-global-slot="${globalIndex + 1}/${globalCount}" data-motion-phase="${Number(spacingRatio.toFixed(4))}" data-colregs-observer-aspect="${colregAspect}"${fallbackRole ? ` data-ocean-fallback="${escapeHtml(fallbackRole)}"` : ''} style="--vessel-width:${width}px;--vessel-bottom:${bottom}px;--vessel-scale:${plane.scale};--vessel-z-index:${plane.zIndex};--vessel-duration:${duration}s;--vessel-delay:${delay}s;--vessel-static-left:${staticLeft};--vessel-opacity:${plane.opacity};--vessel-bob:${plane.bob}px">
    <div class="rc5-ocean-vessel__scale">
      <div class="rc5-ocean-vessel__body">
        <div class="rc5-vessel-plane-wake" aria-hidden="true"></div>
        ${renderer(vessel.lightsProfile, colregAspect)}
        ${namePlate}
      </div>
    </div>
  </div>`;
}

function fallbackSailboatMarkup() {
  const fallback = { id: 'fallback-sailing-vessel-rule25', name: 'Sailboat', model: 'sailingVessel', lightsProfile: 'sailingRule25', loaM: 18 };
  return vesselMarkup(fallback, 0, {
    planeKey: 'mid',
    planeIndex: 0,
    planeCount: 1,
    globalIndex: 0,
    globalCount: 1,
    phase: 0.15,
    fallback: 'sailing-rule25',
  }).replace('rc5-ocean-vessel rc5-ocean-vessel--', 'rc5-ocean-vessel rc5-ocean-vessel--fallback-sailing rc5-ocean-vessel--');
}

function renderLiveOceanMarkup(visible = []) {
  const deterministicPlaneKeys = new Map();
  visible
    .map((vessel, index) => ({
      vessel,
      index,
      sortKey: hashText(`${vessel.id || ''}|${vessel.name || ''}|${vessel.model || ''}|plane-balance`),
    }))
    .sort((a, b) => (a.sortKey - b.sortKey) || (a.index - b.index))
    .forEach((item, balancedIndex) => {
      deterministicPlaneKeys.set(item.index, SEA_PLANE_ORDER[balancedIndex % SEA_PLANE_ORDER.length]);
    });

  const planned = visible.map((vessel, index) => ({
    vessel,
    index,
    planeKey: deterministicPlaneKeys.get(index) || assignSeaPlane(vessel, index),
  }));
  const planeTotals = planned.reduce((totals, item) => {
    totals[item.planeKey] = (totals[item.planeKey] || 0) + 1;
    return totals;
  }, {});
  const planeSeen = {};
  const scheduledItems = [];
  const planeBuckets = SEA_PLANE_ORDER.reduce((buckets, planeKey) => {
    buckets[planeKey] = planned.filter(item => item.planeKey === planeKey);
    return buckets;
  }, {});
  const maxPlaneCount = Math.max(...SEA_PLANE_ORDER.map(planeKey => planeBuckets[planeKey].length), 0);

  for (let round = 0; round < maxPlaneCount; round += 1) {
    SEA_PLANE_ORDER.forEach((planeKey) => {
      const item = planeBuckets[planeKey][round];
      if (item) scheduledItems.push(item);
    });
  }

  const globalSlotCount = Math.max(1, scheduledItems.length);
  const phaseByOriginalIndex = new Map();
  scheduledItems.forEach((item, globalIndex) => {
    phaseByOriginalIndex.set(item.index, {
      globalIndex,
      globalCount: globalSlotCount,
      phase: (globalIndex + 0.5) / globalSlotCount,
    });
  });

  return oceanBaseMarkup(planned.map((item) => {
    const planeIndex = planeSeen[item.planeKey] || 0;
    planeSeen[item.planeKey] = planeIndex + 1;
    const globalSlot = phaseByOriginalIndex.get(item.index) || { globalIndex: planeIndex, globalCount: planeTotals[item.planeKey], phase: (planeIndex + 0.5) / Math.max(1, planeTotals[item.planeKey]) };
    return vesselMarkup(item.vessel, item.index, {
      planeKey: item.planeKey,
      planeIndex,
      planeCount: planeTotals[item.planeKey],
      globalIndex: globalSlot.globalIndex,
      globalCount: globalSlot.globalCount,
      phase: globalSlot.phase,
    });
  }).join(''));
}

function finishFallbackRetirement(ocean, visible, renderSignature) {
  if (!ocean) return;
  ocean.classList.remove('rc5-ocean-decoration--fallback-retiring');
  ocean.classList.remove('rc5-ocean-decoration--fallback');
  ocean.classList.add('rc5-ocean-decoration--live');
  ocean.innerHTML = renderLiveOceanMarkup(visible);
  markOceanRendered(ocean, renderSignature);
}

function retireFallbackThenRenderLive(ocean, visible, renderSignature) {
  const fallbackVessel = ocean?.querySelector?.('.rc5-ocean-vessel--fallback-sailing');
  if (!fallbackVessel) {
    finishFallbackRetirement(ocean, visible, renderSignature);
    return;
  }
  const currentToken = String(Date.now());
  ocean.setAttribute('data-ocean-retire-token', currentToken);
  ocean.classList.add('rc5-ocean-decoration--fallback-retiring');
  fallbackVessel.classList.add('rc5-ocean-vessel--retiring-fallback');
  if (typeof fallbackVessel.getBoundingClientRect === 'function' && typeof ocean.getBoundingClientRect === 'function') {
    const vesselRect = fallbackVessel.getBoundingClientRect();
    const oceanRect = ocean.getBoundingClientRect();
    const currentX = Number.isFinite(vesselRect.left - oceanRect.left) ? (vesselRect.left - oceanRect.left) : 0;
    fallbackVessel.style.setProperty('--retire-from', `${currentX}px`);
  }
  const complete = () => {
    if (ocean.getAttribute('data-ocean-retire-token') !== currentToken) return;
    ocean.removeAttribute('data-ocean-retire-token');
    finishFallbackRetirement(ocean, visible, renderSignature);
  };
  window.setTimeout(complete, 1450);
}

function oceanBaseMarkup(content = '') {
  return `<div class="rc5-ocean-wavefield rc5-ocean-wavefield--back"></div>
    <div class="rc5-ocean-plane rc5-ocean-plane--far"></div>
    <div class="rc5-ocean-plane rc5-ocean-plane--mid"></div>
    <div class="rc5-ocean-plane rc5-ocean-plane--front"></div>
    <div class="rc5-ocean-wavefield rc5-ocean-wavefield--front"></div>
    <div class="rc5-ocean-vessels" aria-hidden="true">${content}</div>`;
}

// Single global ocean source: every page uses the shell container; real sea vessels are shown first, fallback sailboat only when no vessel is currently at sea.
function resolveOceanTarget() {
  return document.querySelector('[data-ocean-animation]');
}

export function showDashboardOcean() {
  const ocean = resolveOceanTarget();
  if (!ocean) return;
  ocean.hidden = false;
  ocean.setAttribute('data-dashboard-ocean-active', '1');
}

export function hideDashboardOcean() {
  const ocean = resolveOceanTarget();
  if (!ocean) return;
  ocean.hidden = true;
  ocean.classList.remove('rc5-ocean-decoration--live', 'rc5-ocean-decoration--fallback');
  ocean.removeAttribute('data-dashboard-ocean-active');
  clearOceanRendered(ocean);
  ocean.innerHTML = '';
}

export function renderOceanVessels(vessels = []) {
  const ocean = resolveOceanTarget();
  if (!ocean) return;
  showDashboardOcean();
  const visible = dedupeVesselsByIdentity(Array.isArray(vessels) ? vessels : []);
  const renderSignature = oceanRenderSignature(visible);
  ocean.classList.toggle('rc5-ocean-decoration--live', visible.length > 0);
  ocean.classList.toggle('rc5-ocean-decoration--fallback', visible.length === 0);
  if (hasSameOceanRender(ocean, renderSignature)) return;

  if (!visible.length) {
    ocean.removeAttribute('data-ocean-retire-token');
    ocean.classList.remove('rc5-ocean-decoration--live', 'rc5-ocean-decoration--fallback-retiring');
    ocean.classList.add('rc5-ocean-decoration--fallback');
    ocean.innerHTML = oceanBaseMarkup(fallbackSailboatMarkup());
    markOceanRendered(ocean, renderSignature);
    return;
  }

  const isFallbackVisible = ocean.classList.contains('rc5-ocean-decoration--fallback')
    && ocean.querySelector?.('.rc5-ocean-vessel--fallback-sailing');
  if (isFallbackVisible) {
    retireFallbackThenRenderLive(ocean, visible, renderSignature);
    return;
  }

  ocean.removeAttribute('data-ocean-retire-token');
  ocean.classList.remove('rc5-ocean-decoration--fallback', 'rc5-ocean-decoration--fallback-retiring');
  ocean.classList.add('rc5-ocean-decoration--live');
  ocean.innerHTML = renderLiveOceanMarkup(visible);
  markOceanRendered(ocean, renderSignature);
}

export function renderNeutralOcean() {
  hideDashboardOcean();
}
